import { z } from 'zod/mini';
import { OrderLineGroupSchema, OrderLineSchema } from '~/validation/api/packageSessionResponse';
import OptionRuleGroupInterface from './optionRuleGroupInterface';

export default class PerPax implements OptionRuleGroupInterface {
  // eslint-disable-next-line class-methods-use-this
  apply(
    orderLines: z.infer<typeof OrderLineSchema>[],
    _defaultOrderLines: z.infer<typeof OrderLineSchema>[],
    group: z.infer<typeof OrderLineGroupSchema>,
    _pax: number,
  ): z.infer<typeof OrderLineSchema>[] {
    return orderLines.map((orderLine) => {
      const orderLineClone = { ...orderLine };

      orderLineClone.per_pax = group.order_lines.includes(orderLine.id);

      return orderLineClone;
    });
  }

  // eslint-disable-next-line class-methods-use-this
  errors(
    _orderLines: z.infer<typeof OrderLineSchema>[],
    _defaultOrderLines: z.infer<typeof OrderLineSchema>[],
    _group: z.infer<typeof OrderLineGroupSchema>,
    _pax: number,
  ): string[] {
    return [];
  }
}
